import { render, staticRenderFns } from "./favorite-page-container.vue?vue&type=template&id=2937bd3a"
import script from "./favorite-page-container.vue?vue&type=script&lang=js"
export * from "./favorite-page-container.vue?vue&type=script&lang=js"
import style0 from "./favorite-page-container.vue?vue&type=style&index=0&id=2937bd3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports